import api from '../../api'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  getAll: (state) => state.all.sort(function (a, b) {
    return (moment(a.latestEstimatePickUpTime) < moment(b.latestEstimatePickUpTime) ? -1 : 1)
  })
}

const actions = {
  fetchAll ({ rootGetters, commit }, { areaId, mobilityId, statuses }) {
    return new Promise((resolve, reject) => {
      api.getReservations(rootGetters['user/getToken'], areaId, mobilityId, statuses)
        .then((reservations) => {
          commit('setReservations', reservations)
          resolve()
        })
        .catch(() =>  reject())
    })
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setReservations (state, reservations) {
    state.all = reservations
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}